import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "./lib/store";
import { Layout } from "./components/Layout";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Accounts from "./pages/Accounts";
import AccountDetail from "./pages/AccountDetail";
import Contacts from "./pages/Contacts";
import Leads from "./pages/Leads";
import Opportunities from "./pages/Opportunities";
import Complaints from "./pages/Complaints";
import ComplaintDetail from "./pages/ComplaintDetail";
import Quotes from "./pages/Quotes";
import QuoteDetail from "./pages/QuoteDetail";
import Activities from "./pages/Activities";
import TradeFair from "./pages/TradeFair";
import Samples from "./pages/Samples";
import Contracts from "./pages/Contracts";
import Orders from "./pages/Orders";
import OrderDetail from "./pages/OrderDetail";
import Articles from "./pages/Articles";
import Conditions from "./pages/Conditions";
import OpenConfirmations from "./pages/OpenConfirmations";
import OrderInbox from "./pages/OrderInbox";
import InterfaceMonitor from "./pages/InterfaceMonitor";
import ContractDeadlines from "./pages/ContractDeadlines";
import Forecast from "./pages/Forecast";
import CustomerForecast from "./pages/CustomerForecast";
import ForecastApprovals from "./pages/ForecastApprovals";
import Reports from "./pages/Reports";
import IdeasBugs from "./pages/IdeasBugs";
import IdeaDetail from "./pages/IdeaDetail";
import Roadmap from "./pages/Roadmap";
import RoadmapDetail from "./pages/RoadmapDetail";
import Locations from "./pages/Locations";
import PlantView from "./pages/PlantView";
import Suppliers from "./pages/Suppliers";
import SupplierContacts from "./pages/SupplierContacts";
import SupplierDetail from "./pages/SupplierDetail";
import SupplierDocuments from "./pages/SupplierDocuments";
import PurchaseRequisitions from "./pages/PurchaseRequisitions";
import PurchaseOrders from "./pages/PurchaseOrders";
import InvoiceExceptions from "./pages/InvoiceExceptions";
import ErpMonitor from "./pages/ErpMonitor";
import SupplierComplaints from "./pages/SupplierComplaints";
import SpendAnalytics from "./pages/SpendAnalytics";
import PriceVariance from "./pages/PriceVariance";
import AiGovernance from "./pages/AiGovernance";
import Scorecards from "./pages/Scorecards";
import Consignment from "./pages/Consignment";
import Savings from "./pages/Savings";
import AiAgents from "./pages/AiAgents";
import AiCosts from "./pages/AiCosts";
import QuoteComparison from "./pages/QuoteComparison";
import Admin from "./pages/Admin";
import Guide from "./pages/Guide";
import Faq from "./pages/Faq";
import OutlookAddin from "./pages/OutlookAddin";
import MyAccess from "./pages/MyAccess";
import MyProfile from "./pages/MyProfile";
import IamDashboard from "./pages/iam/IamDashboard";
import IamUsers from "./pages/iam/Users";
import IamUserDetail from "./pages/iam/UserDetail";
import IamRoles from "./pages/iam/Roles";
import IamOrg from "./pages/iam/OrgStructure";
import IamAuth from "./pages/iam/AuthSecurity";
import IamAudit from "./pages/iam/AuditLog";
import PortalApp from "./pages/Portal";
import SupplierPortal from "./pages/SupplierPortal";
import SupplierPortalAdmin from "./pages/SupplierPortalAdmin";

function Shell() {
  const { user, checking } = useApp();
  if (checking) {
    return (
      <div className="min-h-screen bg-[#F4F5F7] flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-[#1B2A4A] border-t-[#F5A623] animate-spin" />
      </div>
    );
  }
  if (!user) return <Login />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/accounts/:id" element={<AccountDetail />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/complaints" element={<Complaints />} />
        <Route path="/complaints/:id" element={<ComplaintDetail />} />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/quotes/:id" element={<QuoteDetail />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/tradefair" element={<TradeFair />} />
        <Route path="/samples" element={<Samples />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/conditions" element={<Conditions />} />
        <Route path="/open-confirmations" element={<OpenConfirmations />} />
        <Route path="/order-inbox" element={<OrderInbox />} />
        <Route path="/interface-monitor" element={<InterfaceMonitor />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/contract-deadlines" element={<ContractDeadlines />} />
        <Route path="/forecast" element={<Forecast />} />
        <Route path="/customer-forecast" element={<CustomerForecast />} />
        <Route path="/forecast-approvals" element={<ForecastApprovals />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/ideas" element={<IdeasBugs />} />
        <Route path="/ideas/:id" element={<IdeaDetail />} />
        <Route path="/roadmap" element={<Roadmap />} />
        <Route path="/roadmap/:id" element={<RoadmapDetail />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/plant-view" element={<PlantView />} />
        <Route path="/suppliers" element={<Suppliers />} />
        <Route path="/supplier-contacts" element={<SupplierContacts />} />
        <Route path="/suppliers/:id" element={<SupplierDetail />} />
        <Route path="/supplier-documents" element={<SupplierDocuments />} />
        <Route path="/purchase-requisitions" element={<PurchaseRequisitions />} />
        <Route path="/purchase-orders" element={<PurchaseOrders />} />
        <Route path="/invoice-exceptions" element={<InvoiceExceptions />} />
        <Route path="/erp-monitor" element={<ErpMonitor />} />
        <Route path="/supplier-complaints" element={<SupplierComplaints />} />
        <Route path="/supplier-portal-admin" element={<SupplierPortalAdmin />} />
        <Route path="/spend-analytics" element={<SpendAnalytics />} />
        <Route path="/price-variance" element={<PriceVariance />} />
        <Route path="/ai-governance" element={<AiGovernance />} />
        <Route path="/scorecards" element={<Scorecards />} />
        <Route path="/consignment" element={<Consignment />} />
        <Route path="/savings" element={<Savings />} />
        <Route path="/ai-agents" element={<AiAgents />} />
        <Route path="/ai-costs" element={<AiCosts />} />
        <Route path="/quote-comparison" element={<QuoteComparison />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/outlook-addin" element={<OutlookAddin />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/my-access" element={<MyAccess />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/iam" element={<IamDashboard />} />
        <Route path="/iam/users" element={<IamUsers />} />
        <Route path="/iam/users/:id" element={<IamUserDetail />} />
        <Route path="/iam/roles" element={<IamRoles />} />
        <Route path="/iam/org" element={<IamOrg />} />
        <Route path="/iam/auth" element={<IamAuth />} />
        <Route path="/iam/audit" element={<IamAudit />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
}

function App() {
  if (window.location.pathname.startsWith("/supplier-portal") &&
      !window.location.pathname.startsWith("/supplier-portal-admin")) {
    return (
      <>
        <SupplierPortal />
        <Toaster position="top-right" richColors />
      </>
    );
  }
  if (window.location.pathname.startsWith("/portal")) {
    return (
      <>
        <PortalApp />
        <Toaster position="top-right" richColors />
      </>
    );
  }
  return (
    <AppProvider>
      <BrowserRouter>
        <Shell />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
